var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOldZixxarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.252,
    height: 27.658,
    viewBox: "0 0 146.252 27.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zixxar-logo",
    transform: "translate(-3.735 -14.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80059",
    "data-name": "Path 80059",
    d: "M3.735-27.122h26.82v-3.562h-19.7L30.136-51.218V-54.78H4.154v3.562H23.012L3.735-30.684Zm31.43,0h5.448V-47.237H35.165Zm0-23.467h5.448V-54.78H35.165Zm8.8,23.467h6.747L59.47-37.305l8.758,10.183h6.747L62.865-41.2,74.556-54.78H67.809L59.47-45.1l-8.339-9.68H44.384L56.076-41.2Zm32.268,0h6.747l8.758-10.183L100.5-27.122h6.747L95.132-41.2,106.824-54.78h-6.747L91.738-45.1,83.4-54.78H76.652L88.343-41.2Zm33.944-4.693c0,3.143,1.97,4.693,5.867,4.693h15.505V-42.543c0-3.143-1.97-4.693-5.867-4.693H111.853v3.143h12.781c.964,0,1.467.377,1.467,1.173v3.646H116.043c-3.9,0-5.867,1.551-5.867,4.693Zm5.448.377v-3.52c0-.8.5-1.173,1.467-1.173h9.01v5.867h-9.01C116.127-30.265,115.624-30.642,115.624-31.438ZM137-27.122h5.448v-15.8c0-.8.5-1.173,1.467-1.173h6.076v-3.143h-7.124c-3.9,0-5.867,1.551-5.867,4.693Z",
    transform: "translate(0 68.891)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldZixxarLogo);
export default __webpack_public_path__ + "static/media/old-zixxar-logo.4002fb842c9f4c76f749825c39539afb.svg";
export { ForwardRef as ReactComponent };